var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 59,
    fill: "#FFF536"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3327 70.668H70.666V66.0013H47.3327V70.668ZM58.9993 63.668L68.3327 54.3346L65.066 51.068L61.3327 54.6846V45.0013H56.666V54.6846L52.9327 51.068L49.666 54.3346L58.9993 63.668ZM58.9993 82.3346C55.7716 82.3346 52.7382 81.7221 49.8993 80.4971C47.0605 79.2721 44.591 77.6096 42.491 75.5096C40.391 73.4096 38.7285 70.9402 37.5035 68.1013C36.2785 65.2624 35.666 62.2291 35.666 59.0013C35.666 55.7735 36.2785 52.7402 37.5035 49.9013C38.7285 47.0624 40.391 44.593 42.491 42.493C44.591 40.393 47.0605 38.7305 49.8993 37.5055C52.7382 36.2805 55.7716 35.668 58.9993 35.668C62.2271 35.668 65.2605 36.2805 68.0993 37.5055C70.9382 38.7305 73.4077 40.393 75.5077 42.493C77.6077 44.593 79.2702 47.0624 80.4952 49.9013C81.7202 52.7402 82.3327 55.7735 82.3327 59.0013C82.3327 62.2291 81.7202 65.2624 80.4952 68.1013C79.2702 70.9402 77.6077 73.4096 75.5077 75.5096C73.4077 77.6096 70.9382 79.2721 68.0993 80.4971C65.2605 81.7221 62.2271 82.3346 58.9993 82.3346Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.2181f90d5dfcc4ac971c72c687c5ecb6.svg";
export { ForwardRef as ReactComponent };